import React from 'react';
import { motion } from 'framer-motion';
import { Factory, Truck, Users, CheckCircle } from 'lucide-react';
const services = [{
  id: 'company',
  title: 'On-Site Gold Smelting',
  subtitle: 'At Company Premises',
  description: 'We provide gold smelting services at our secure company location in Bagamoyo Road, Dar es Salaam. This service is ideal for clients who prefer smelting in a controlled environment using professional equipment.',
  features: ['Secure and controlled smelting process', 'Professional handling of gold', 'Accurate smelting results', 'Fast and reliable service'],
  icon: Factory,
  image: 'https://cdn.magicpatterns.com/uploads/7DsBX9xyErFwukfyPcabrV/images_(1).jpg'
}, {
  id: 'mobile',
  title: 'Mobile Smelting Services',
  subtitle: 'We Come To You',
  description: 'Our mobile smelting service allows clients to book our professional smelters to travel to their location and carry out gold smelting on-site. Suitable for mining sites, private premises, and remote locations.',
  features: ['Convenient and flexible', 'Professional smelting at your location', 'Saves time and transportation risks', 'Reliable and confidential service'],
  icon: Truck,
  image: 'https://cdn.magicpatterns.com/uploads/6YkLRp9DYp7eH5PC9cXWdY/images.jpg'
}, {
  id: 'consultation',
  title: 'Professional Consultation',
  subtitle: 'Expert Guidance',
  description: 'We offer consultation services to clients who need guidance on gold smelting processes, preparation, and best practices before smelting. Get expert advice from our experienced team.',
  features: ['Process optimization advice', 'Purity assessment guidance', 'Safety protocols and standards', 'Market preparation insights'],
  icon: Users,
  image: 'https://cdn.magicpatterns.com/uploads/dcnmsD5Gpe7vyfSkiT6ham/download.jpg'
}];
export function Services() {
  return <section id="services" className="py-24 px-4 sm:px-6 lg:px-8 bg-black-rich relative z-10" data-id="element-200">
      <div className="max-w-7xl mx-auto" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-20 text-center" data-id="element-202">
          <span className="text-gold-500 font-medium tracking-widest uppercase text-sm" data-id="element-203">
            What We Do
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mt-3 mb-6" data-id="element-204">
            Our Gold Smelting Services
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-205">
            Kings Gold Smelters Company Limited offers flexible gold smelting
            solutions designed to meet the needs of different clients across
            Tanzania.
          </p>
        </motion.div>

        <div className="space-y-24" data-id="element-206">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 items-center`} data-id="element-207">
              {/* Image Side */}
              <div className="w-full lg:w-1/2" data-id="element-208">
                <div className="relative rounded-lg overflow-hidden border border-gray-800 group" data-id="element-209">
                  <div className="absolute inset-0 bg-gold-500/10 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-210" />
                  <img src={service.image} alt={service.title} className="w-full aspect-[4/3] object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-211" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black via-black/80 to-transparent z-20" data-id="element-212">
                    <div className="flex items-center gap-3 text-gold-400" data-id="element-213">
                      <service.icon className="w-6 h-6" data-id="element-214" />
                      <span className="font-medium tracking-wider uppercase text-sm" data-id="element-215">
                        {service.subtitle}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Content Side */}
              <div className="w-full lg:w-1/2 space-y-6" data-id="element-216">
                <h3 className="text-3xl font-bold text-white" data-id="element-217">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-218">
                  {service.description}
                </p>

                <ul className="space-y-4 pt-4" data-id="element-219">
                  {service.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-220">
                      <CheckCircle className="w-5 h-5 text-gold-500 flex-shrink-0 mt-1" data-id="element-221" />
                      <span className="text-gray-300" data-id="element-222">{feature}</span>
                    </li>)}
                </ul>

                <div className="pt-6" data-id="element-223">
                  <a href="#contact" className="inline-flex items-center text-gold-400 hover:text-white font-medium transition-colors border-b border-gold-500/30 hover:border-white pb-1" data-id="element-224">
                    Book this service
                  </a>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}